var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.paymentInProgress,
            expression: "!paymentInProgress",
          },
        ],
        attrs: { id: "yodahCheckout" },
      },
      [
        _vm.isPaid
          ? _c("div", { attrs: { id: "isPaid" } }, [
              _c("h2", [_vm._v("ORDER CONFIRMATION")]),
              _vm._v(" "),
              _c("p", { staticClass: "lead" }, [
                _vm._v("Thank you for your order."),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "lead" }, [
                _vm._v(
                  "Your payment has been successful and you will receive a confirmation email shortly."
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("If you have any questions about your order, please "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/contact",
                      title: "Contact Us",
                      target: "_blank",
                    },
                  },
                  [_vm._v("contact us")]
                ),
                _vm._v(" quoting order number: " + _vm._s(_vm.orderId)),
              ]),
            ])
          : _vm.payPalOrderDetails
          ? _c("div", [
              _c("h2", [_vm._v("COMPLETE YOUR ORDER")]),
              _vm._v(" "),
              _c("p", { staticClass: "lead" }, [
                _vm._v(
                  "PayPal has authorized your payment and confirmed your details as;"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.payPalOrderDetails.payer.name.given_name +
                      " " +
                      _vm.payPalOrderDetails.payer.name.surname +
                      " - " +
                      _vm.payPalOrderDetails.payer.email_address
                  )
                ),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Deliver to:")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.payPalOrderDetails.purchase_units[0].shipping.name
                        .full_name
                    )
                ),
                _vm.payPalOrderDetails.purchase_units[0].shipping.name.full_name
                  ? _c("br")
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.payPalOrderDetails.purchase_units[0].shipping.address
                        .address_line_1
                    )
                ),
                _vm.payPalOrderDetails.purchase_units[0].shipping.address
                  .address_line_1
                  ? _c("br")
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.payPalOrderDetails.purchase_units[0].shipping.address
                        .address_line_2
                    )
                ),
                _vm.payPalOrderDetails.purchase_units[0].shipping.address
                  .address_line_2
                  ? _c("br")
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.payPalOrderDetails.purchase_units[0].shipping.address
                        .admin_area_2
                    )
                ),
                _vm.payPalOrderDetails.purchase_units[0].shipping.address
                  .admin_area_2
                  ? _c("br")
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.payPalOrderDetails.purchase_units[0].shipping.address
                        .admin_area_1
                    )
                ),
                _vm.payPalOrderDetails.purchase_units[0].shipping.address
                  .admin_area_1
                  ? _c("br")
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.payPalOrderDetails.purchase_units[0].shipping.address
                        .postal_code +
                        " " +
                        _vm.payPalOrderDetails.purchase_units[0].shipping
                          .address.country_code
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "To complete the order please provide your phone number and accept our terms and conditions:"
                ),
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { name: "payPalForm", id: "payPalForm" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.completePayPalOrder.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("text-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:14",
                        expression: "'required|max:14'",
                      },
                    ],
                    staticClass: "flex-50",
                    attrs: {
                      label: "Tel.",
                      name: "tel",
                      type: "text",
                      placeholder: "Tel.",
                      required: "true",
                      vErrors: _vm.errors,
                      autocomplete: "tel",
                    },
                    model: {
                      value: _vm.telMobile,
                      callback: function ($$v) {
                        _vm.telMobile = $$v
                      },
                      expression: "telMobile",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "accept" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.acceptPayPalTerms,
                          expression: "acceptPayPalTerms",
                        },
                      ],
                      attrs: { id: "accept", type: "checkbox", value: "0" },
                      domProps: {
                        checked: Array.isArray(_vm.acceptPayPalTerms)
                          ? _vm._i(_vm.acceptPayPalTerms, "0") > -1
                          : _vm.acceptPayPalTerms,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.acceptPayPalTerms,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "0",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.acceptPayPalTerms = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.acceptPayPalTerms = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.acceptPayPalTerms = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "terms",
                      domProps: { innerHTML: _vm._s(_vm.termsText) },
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "complete-order btn btn-lg btn-primary",
                          attrs: {
                            type: "submit",
                            disabled: !_vm.acceptPayPalTerms || _vm.submitting,
                          },
                        },
                        [
                          !_vm.submitting
                            ? _c("span", [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(" Complete Order"),
                              ])
                            : _c("span", [
                                _vm._v("Processing... "),
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-pulse",
                                }),
                              ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.paypalErrorMsg
                      ? _c("div", { staticClass: "help has-error" }, [
                          _vm._v(_vm._s(_vm.paypalErrorMsg)),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ])
          : _c("div", [
              _vm.ppClientId ? _c("hr") : _vm._e(),
              _vm._v(" "),
              _c("div", { attrs: { id: "paypal-button-container" } }),
              _vm._v(" "),
              _c("div", {
                attrs: {
                  "data-pp-message": "",
                  "data-pp-style-layout": "text",
                  "data-pp-style-logo-type": "inline",
                  "data-pp-style-text-color": "black",
                  "data-pp-amount": _vm.basketValues.gross,
                },
              }),
              _vm._v(" "),
              _vm.paypalErrorMsg
                ? _c("div", { staticClass: "help has-error" }, [
                    _vm._v(_vm._s(_vm.paypalErrorMsg)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.ppClientId
                ? _c("div", { staticClass: "divider m-t-30" }, [
                    _c("h3", { staticClass: "text-center or" }, [_vm._v("Or")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("h3", { staticClass: "checkout-text text-center" }, [
                _vm._v("Checkout securely below"),
              ]),
              _vm._v(" "),
              _vm.cardPaymentOn
                ? _c("img", {
                    staticClass: "center-block",
                    attrs: {
                      src: "/wp-content/plugins/yodah/images/visa-mastercard-amex-30.png",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { name: "guestCheckoutForm", id: "guestCheckoutForm" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitOrder.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("h2", [_vm._v("Your details")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha",
                            expression: "'alpha'",
                          },
                        ],
                        staticClass: "flex-20",
                        attrs: {
                          label: "Title",
                          name: "title",
                          type: "text",
                          placeholder: "Title (optional)",
                          vErrors: _vm.errors,
                          autocomplete: "honorific-prefix",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.title,
                          callback: function ($$v) {
                            _vm.title = $$v
                          },
                          expression: "title",
                        },
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|alpha|min:3",
                            expression: "'required|alpha|min:3'",
                          },
                        ],
                        staticClass: "flex-40",
                        attrs: {
                          label: "First Name",
                          name: "firstName",
                          type: "text",
                          placeholder: "First Name",
                          required: "true",
                          vErrors: _vm.errors,
                          autcomplete: "given-name",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.firstName,
                          callback: function ($$v) {
                            _vm.firstName = $$v
                          },
                          expression: "firstName",
                        },
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|alpha|min:3",
                            expression: "'required|alpha|min:3'",
                          },
                        ],
                        staticClass: "flex-40",
                        attrs: {
                          label: "Last Name",
                          name: "lastName",
                          type: "text",
                          placeholder: "Last Name",
                          required: "true",
                          vErrors: _vm.errors,
                          autocomplete: "family-name",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.lastName,
                          callback: function ($$v) {
                            _vm.lastName = $$v
                          },
                          expression: "lastName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'",
                          },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "Email",
                          name: "email",
                          type: "text",
                          placeholder: "Email",
                          required: "true",
                          vErrors: _vm.errors,
                          autocomplete: "email",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:14",
                            expression: "'required|max:14'",
                          },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "Tel.",
                          name: "tel",
                          type: "text",
                          placeholder: "Tel.",
                          required: "true",
                          vErrors: _vm.errors,
                          autocomplete: "tel",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.telMobile,
                          callback: function ($$v) {
                            _vm.telMobile = $$v
                          },
                          expression: "telMobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("text-input", {
                        directives: [
                          { name: "validate", rawName: "v-validate" },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "Company",
                          name: "company",
                          type: "text",
                          placeholder: "Company Name (optional)",
                          vErrors: _vm.errors,
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.company,
                          callback: function ($$v) {
                            _vm.company = $$v
                          },
                          expression: "company",
                        },
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        directives: [
                          { name: "validate", rawName: "v-validate" },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "VAT No.",
                          name: "vat",
                          type: "text",
                          placeholder: "VAT Number (optional) e.g: GB012345678",
                          vErrors: _vm.errors,
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.vat,
                          callback: function ($$v) {
                            _vm.vat = $$v
                          },
                          expression: "vat",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h2", {}, [_vm._v("Delivery address")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "yodah-flex-container y-checkout-group m-b-10",
                    },
                    [
                      _c("div", { staticClass: "flex-100" }, [
                        _c(
                          "div",
                          { staticClass: "form-group required" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("Select2", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                id: "country",
                                name: "country",
                                settings: { placeholder: "Country*" },
                                options: _vm.countries,
                                autocomplete: "country",
                              },
                              model: {
                                value: _vm.daCountry,
                                callback: function ($$v) {
                                  _vm.daCountry = $$v
                                },
                                expression: "daCountry",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("country"),
                                    expression: "errors.has('country')",
                                  },
                                ],
                                staticClass: "control has-icon has-icon-right",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-warning",
                                  staticStyle: { color: "#E74C3C" },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "help has-error" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.errors.first("country"))
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("div", { staticClass: "flex-100" }, [
                        _c(
                          "div",
                          { staticClass: "form-group required" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("VueGoogleAutoComplete", {
                              key: "deliveryAdd",
                              ref: "deliveryAdd",
                              attrs: {
                                id: "address",
                                name: "street",
                                classname: "form-control",
                                placeholder: "Address",
                                country: ["GB"],
                                onfocus:
                                  "this.setAttribute('autocomplete', 'none')",
                              },
                              on: {
                                placechanged: _vm.autoDeliveryAddress,
                                inputChange: function ($event) {
                                  return _vm.setAddress("delivery", $event)
                                },
                              },
                              model: {
                                value: _vm.daStreet,
                                callback: function ($$v) {
                                  _vm.daStreet = $$v
                                },
                                expression: "daStreet",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.daStreetErrors,
                                    expression: "daStreetErrors",
                                  },
                                ],
                                staticClass: "control has-icon has-icon-right",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-warning",
                                  staticStyle: { color: "#E74C3C" },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "help has-error" }, [
                                  _vm._v(" " + _vm._s(_vm.daStreetErrors)),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        staticClass: "flex-100",
                        attrs: {
                          label: "Apartment Number/Unit/Building",
                          name: "building",
                          type: "text",
                          placeholder:
                            "Apartment Number/Unit/Building (optional)",
                          vErrors: _vm.errors,
                          autocomplete: "none",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.daStreet2,
                          callback: function ($$v) {
                            _vm.daStreet2 = $$v
                          },
                          expression: "daStreet2",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|alpha_spaces",
                            expression: "'required|alpha_spaces'",
                          },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "Town/City",
                          name: "city",
                          type: "text",
                          placeholder: "Town/City",
                          required: "true",
                          vErrors: _vm.errors,
                          autocomplete: "address-level2",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.daCity,
                          callback: function ($$v) {
                            _vm.daCity = $$v
                          },
                          expression: "daCity",
                        },
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "Post Code",
                          name: "post_code",
                          type: "text",
                          placeholder: "Post Code",
                          required: "true",
                          vErrors: _vm.errors,
                          autocomplete: "postal-code",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.daPostCode,
                          callback: function ($$v) {
                            _vm.daPostCode = $$v
                          },
                          expression: "daPostCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_spaces",
                            expression: "'alpha_spaces'",
                          },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "Delivery Contact",
                          name: "contact",
                          type: "text",
                          placeholder: "Delivery Contact",
                          vErrors: _vm.errors,
                          autocomplete: "none",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.daContactName,
                          callback: function ($$v) {
                            _vm.daContactName = $$v
                          },
                          expression: "daContactName",
                        },
                      }),
                      _vm._v(" "),
                      _c("text-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_dash",
                            expression: "'alpha_dash'",
                          },
                        ],
                        staticClass: "flex-50",
                        attrs: {
                          label: "Delivery Contact Tel.",
                          name: "contact_tel",
                          type: "text",
                          placeholder: "Delivery Contact Tel.",
                          vErrors: _vm.errors,
                          autocomplete: "none",
                        },
                        on: { blur: _vm.onCheckoutFormUpdated },
                        model: {
                          value: _vm.daContactTel,
                          callback: function ($$v) {
                            _vm.daContactTel = $$v
                          },
                          expression: "daContactTel",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "yodah-flex-container y-checkout-group" },
                    [
                      _c("div", { staticClass: "flex-100" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "notes" } }, [
                            _vm._v("Delivery Instructions"),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.daNotes,
                                expression: "daNotes",
                              },
                            ],
                            staticClass: "form-control input",
                            attrs: {
                              id: "notes",
                              rows: "4",
                              name: "notes",
                              type: "text",
                              placeholder: "Delivery Instructions (optional)",
                              "data-vv-as": "address notes",
                              autocomplete: "shipping notes",
                            },
                            domProps: { value: _vm.daNotes },
                            on: {
                              blur: _vm.onCheckoutFormUpdated,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.daNotes = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "control has-icon has-icon-right" },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors[0],
                                    expression: "errors[0]",
                                  },
                                ],
                                staticClass: "fa fa-warning",
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors[0],
                                      expression: "errors[0]",
                                    },
                                  ],
                                  staticClass: "help has-error",
                                },
                                [_vm._v(_vm._s(_vm.errors[0]))]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-t-30" }, [
                    _c("hr"),
                    _vm._v(" "),
                    _c("h2", {}, [_vm._v("Billing address")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("label", { attrs: { for: "same" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.sameAddress,
                              expression: "sameAddress",
                            },
                          ],
                          attrs: { id: "same", type: "checkbox", value: "1" },
                          domProps: {
                            checked: Array.isArray(_vm.sameAddress)
                              ? _vm._i(_vm.sameAddress, "1") > -1
                              : _vm.sameAddress,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.sameAddress,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "1",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.sameAddress = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.sameAddress = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.sameAddress = $$c
                                }
                              },
                              _vm.onCheckoutFormUpdated,
                            ],
                          },
                        }),
                        _vm._v(
                          "\n              Same as delivery address\n            "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  !_vm.sameAddress
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "yodah-flex-container y-checkout-group m-b-10",
                          },
                          [
                            _c("div", { staticClass: "flex-100" }, [
                              _c(
                                "div",
                                { staticClass: "form-group required" },
                                [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("Select2", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      id: "billing-country",
                                      name: "billing_country",
                                      settings: { placeholder: "Country" },
                                      options: _vm.countries,
                                      autocomplete: "country-name",
                                    },
                                    model: {
                                      value: _vm.baCountry,
                                      callback: function ($$v) {
                                        _vm.baCountry = $$v
                                      },
                                      expression: "baCountry",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.errors.has("billing_country"),
                                          expression:
                                            "errors.has('billing_country')",
                                        },
                                      ],
                                      staticClass:
                                        "control has-icon has-icon-right",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-warning",
                                        staticStyle: { color: "#E74C3C" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "help has-error" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "billing_country"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "yodah-flex-container y-checkout-group",
                          },
                          [
                            _c("div", { staticClass: "flex-100" }, [
                              _c(
                                "div",
                                { staticClass: "form-group required" },
                                [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c("VueGoogleAutoComplete", {
                                    ref: "billingAdd",
                                    attrs: {
                                      id: "billingAddress",
                                      name: "billing street",
                                      classname: "form-control",
                                      placeholder: "Address",
                                      country: [_vm.billingAddress.country],
                                      onfocus:
                                        "this.setAttribute('autocomplete', 'none')",
                                    },
                                    on: {
                                      placechanged: _vm.autoBillingAddress,
                                      inputChange: function ($event) {
                                        return _vm.setAddress("billing", $event)
                                      },
                                    },
                                    model: {
                                      value: _vm.baStreet,
                                      callback: function ($$v) {
                                        _vm.baStreet = $$v
                                      },
                                      expression: "baStreet",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.baStreetErrors,
                                          expression: "baStreetErrors",
                                        },
                                      ],
                                      staticClass:
                                        "control has-icon has-icon-right",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-warning",
                                        staticStyle: { color: "#E74C3C" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "help has-error" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.baStreetErrors)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "yodah-flex-container y-checkout-group",
                          },
                          [
                            _c("text-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "",
                                  expression: "''",
                                },
                              ],
                              staticClass: "flex-100",
                              attrs: {
                                label: "Apartment Number/Unit/Building",
                                name: "billing_street2",
                                type: "text",
                                placeholder:
                                  "Apartment Number/Unit/Building (optional)",
                                vErrors: _vm.errors,
                                autocomplete: "none",
                              },
                              on: { blur: _vm.onCheckoutFormUpdated },
                              model: {
                                value: _vm.baStreet2,
                                callback: function ($$v) {
                                  _vm.baStreet2 = $$v
                                },
                                expression: "baStreet2",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "yodah-flex-container y-checkout-group",
                          },
                          [
                            _c("text-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|alpha_spaces",
                                  expression: "'required|alpha_spaces'",
                                },
                              ],
                              staticClass: "flex-50",
                              attrs: {
                                label: "Town/City",
                                name: "billing_city",
                                type: "text",
                                placeholder: "Town/City",
                                required: "true",
                                vErrors: _vm.errors,
                                autocomplete: "address-level2",
                              },
                              on: { blur: _vm.onCheckoutFormUpdated },
                              model: {
                                value: _vm.baCity,
                                callback: function ($$v) {
                                  _vm.baCity = $$v
                                },
                                expression: "baCity",
                              },
                            }),
                            _vm._v(" "),
                            _c("text-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              staticClass: "flex-50",
                              attrs: {
                                label: "Post Code",
                                name: "billing_post_code",
                                type: "text",
                                placeholder: "Post Code",
                                required: "true",
                                vErrors: _vm.errors,
                                autocomplete: "postal-code",
                              },
                              on: { blur: _vm.onCheckoutFormUpdated },
                              model: {
                                value: _vm.baPostCode,
                                callback: function ($$v) {
                                  _vm.baPostCode = $$v
                                },
                                expression: "baPostCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Payment")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-t-10 checkbox" }, [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "terms" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.terms,
                              expression: "terms",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "required m-t-30",
                          attrs: {
                            id: "terms",
                            type: "checkbox",
                            name: "terms",
                            value: "1",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.terms)
                              ? _vm._i(_vm.terms, "1") > -1
                              : _vm.terms,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.terms,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.terms = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.terms = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.terms = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "terms",
                          domProps: { innerHTML: _vm._s(_vm.termsText) },
                        }),
                        _c("sup", { staticClass: "required" }, [_vm._v("*")]),
                      ]
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("terms"),
                            expression: "errors.has('terms')",
                          },
                        ],
                        staticClass: "help has-error",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("terms")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isTruelayerOn
                    ? _c(
                        "vue-recaptcha",
                        {
                          ref: "recaptchaRef",
                          attrs: {
                            sitekey: _vm.recaptchaSiteKey,
                            type: "invisible",
                            badge: "bottomleft",
                            loadRecaptchaScript: true,
                          },
                          on: {
                            verify: function ($event) {
                              return _vm.storeExpressOrderForPayment(
                                $event,
                                "truelayer"
                              )
                            },
                            expired: function ($event) {
                              _vm.token = null
                              _vm.submitDisabled = true
                            },
                            error: _vm.recaptchaError,
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              class: {
                                "btn btn-lg btn-cart w100 btn-primary": true,
                                disabled: _vm.submitting,
                              },
                              attrs: {
                                type: "submit",
                                disabled: _vm.submitting || _vm.submitDisabled,
                                title: "Pay Now",
                              },
                            },
                            [
                              !_vm.truelayerSubmitting
                                ? _c("span", [
                                    _vm._v("Proceed to Secure Bank Payment "),
                                    _c("i", {
                                      staticClass:
                                        "dashicons dashicons-arrow-right-alt",
                                    }),
                                  ])
                                : _c("span", [
                                    _vm._v("Loading payment... "),
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-pulse",
                                    }),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "help-block m-b-30" }, [
                            _vm._v(
                              "Click the button above to setup a fast, safe and secure bank payment to us for your goods. Powered and secured by "
                            ),
                            _c(
                              "a",
                              { attrs: { href: "https://truelayer.com" } },
                              [
                                _vm._v("Truelayer "),
                                _c("i", { staticClass: "fa fa-external-link" }),
                              ]
                            ),
                            _vm._v("."),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cardPaymentOn
                    ? _c(
                        "div",
                        [
                          _vm.cardPaymentType === "ycp" && !_vm.card
                            ? _c(
                                "vue-recaptcha",
                                {
                                  ref: "recaptchaRef",
                                  attrs: {
                                    sitekey: _vm.recaptchaSiteKey,
                                    type: "invisible",
                                    badge: "bottomleft",
                                    loadRecaptchaScript: true,
                                  },
                                  on: {
                                    verify: _vm.submitOrder,
                                    expired: function ($event) {
                                      _vm.token = null
                                      _vm.submitDisabled = true
                                    },
                                    error: _vm.recaptchaError,
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      class: {
                                        "btn btn-lg btn-cart w100 btn-primary": true,
                                        disabled: _vm.submitting,
                                      },
                                      attrs: {
                                        id: "pay-now",
                                        type: "submit",
                                        disabled:
                                          _vm.submitting || _vm.submitDisabled,
                                        title: "Pay Now",
                                      },
                                    },
                                    [
                                      !_vm.submitting
                                        ? _c("span", [
                                            _vm._v(
                                              "Proceed to Secure Card Payment "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "dashicons dashicons-arrow-right-alt",
                                            }),
                                          ])
                                        : _c("span", [
                                            _vm._v("Loading payment... "),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-spinner fa-pulse",
                                            }),
                                          ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-root" }, [
                            _c("div", { staticClass: "card-main" }, [
                              _c(
                                "form",
                                {
                                  staticClass: "m-b-10",
                                  class: {
                                    hidden:
                                      _vm.cardPaymentType === "yma" ||
                                      !_vm.card,
                                    "card-payment-form": true,
                                  },
                                  attrs: { id: "payment-form" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.doCardPayment()
                                    },
                                  },
                                },
                                [
                                  _c("h3", [_vm._v("Enter card details")]),
                                  _vm._v(" "),
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "card-field-error",
                                    attrs: { id: "card-errors", role: "alert" },
                                  }),
                                  _vm._v(" "),
                                  _vm._m(5),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(6),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.cardPaymentType === "yma"
                            ? _c(
                                "vue-recaptcha",
                                {
                                  ref: "recaptchaRef",
                                  attrs: {
                                    sitekey: _vm.recaptchaSiteKey,
                                    type: "invisible",
                                    badge: "bottomleft",
                                    loadRecaptchaScript: true,
                                  },
                                  on: {
                                    verify: function ($event) {
                                      return _vm.storeExpressOrderForPayment(
                                        $event,
                                        "worldpay"
                                      )
                                    },
                                    expired: function ($event) {
                                      _vm.token = null
                                      _vm.submitDisabled = true
                                    },
                                    error: _vm.recaptchaError,
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      class: {
                                        "btn btn-lg btn-cart w100 btn-primary": true,
                                        disabled: _vm.submitting,
                                      },
                                      attrs: {
                                        type: "submit",
                                        disabled:
                                          _vm.submitting || _vm.submitDisabled,
                                        title: "Pay Now",
                                      },
                                    },
                                    [
                                      !_vm.worldpaySubmitting
                                        ? _c("span", [
                                            _vm._v(
                                              "Proceed to Secure Card Payment "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "dashicons dashicons-arrow-right-alt",
                                            }),
                                          ])
                                        : _c("span", [
                                            _vm._v("Loading payment... "),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-spinner fa-pulse",
                                            }),
                                          ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(7),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.paymentInProgress,
            expression: "paymentInProgress",
          },
        ],
        attrs: { id: "yodah-card-payment-iframe-block" },
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-info btn-sm",
            attrs: { title: "Cancel payment and return to checkout" },
            on: { click: _vm.cancelPayment },
          },
          [
            _c("span", {
              staticClass: "dashicons dashicons-arrow-left-alt2 iframe-close",
            }),
            _vm._v(" Cancel Payment\n      "),
          ]
        ),
        _vm._v(" "),
        !_vm.iframeLoaded
          ? _c("div", [
              _vm._v("Loading payment... "),
              _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "country" } }, [
      _vm._v("Country"),
      _c("sup", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "address" } }, [
      _vm._v("Address"),
      _c("sup", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "billing-country" } }, [
      _vm._v("Country"),
      _c("sup", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "billingAddress" } }, [
      _vm._v("Address"),
      _c("sup", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-combo-inputs-row" }, [
      _c("div", {
        staticClass: "card-input card-card-element",
        attrs: { id: "card-element" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("button", { attrs: { id: "submit" } }, [
      _c("div", { staticClass: "spinner hidden", attrs: { id: "spinner" } }),
      _vm._v(" "),
      _c("span", { attrs: { id: "button-text" } }, [_vm._v("Pay")]),
      _c("span", { attrs: { id: "order-amount" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-result hidden" }, [
      _c("p", { staticStyle: { color: "#1ab394", "font-size": "21px" } }, [
        _c("span", [
          _c("i", { staticClass: "fa fa-check" }),
          _vm._v(" Payment completed"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "help-block" }, [
      _vm._v("All transactions are secure and encrypted. We accept: "),
      _c("img", {
        attrs: {
          src: "/wp-content/plugins/yodah/images/visa-mastercard-amex-30.png",
          title: "Secure Card Payment",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }